var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100%",
    viewBox: "0 0 208 174",
    enableBackground: "new 0 0 208 174",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    opacity: 1,
    stroke: "none",
    d: " M129.000000,175.000000  C86.027832,175.000000 43.555660,175.000000 1.041745,175.000000  C1.041745,117.065834 1.041745,59.131630 1.041745,1.098714  C70.222000,1.098714 139.444183,1.098714 208.833191,1.098714  C208.833191,58.999611 208.833191,116.999763 208.833191,175.000000  C182.465256,175.000000 155.982635,175.000000 129.000000,175.000000  M95.000648,150.256042  C95.000648,112.329529 95.000648,74.403008 95.000648,36.571728  C69.698891,30.244295 45.089443,24.089996 20.385693,17.912113  C20.385693,57.766735 20.385693,97.157593 20.385693,136.527252  C45.356567,142.772339 69.959038,148.925293 94.807312,155.139725  C94.888046,153.488037 94.944313,152.337082 95.000648,150.256042  M104.001320,38.954502  C104.001320,77.548492 104.001320,116.142487 104.001320,155.183624  C129.376678,148.829803 154.118851,142.634521 178.696213,136.480515  C178.696213,96.714615 178.696213,57.483276 178.696213,17.918190  C154.173370,24.033230 130.011978,30.044754 105.872131,36.141567  C105.139488,36.326607 104.631584,37.401493 104.001320,38.954502  z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#019D9C",
    opacity: 1,
    stroke: "none",
    d: " M95.000610,150.721069  C94.944313,152.337082 94.888046,153.488037 94.807312,155.139725  C69.959038,148.925293 45.356567,142.772339 20.385693,136.527252  C20.385693,97.157593 20.385693,57.766735 20.385693,17.912113  C45.089443,24.089996 69.698891,30.244295 95.000648,36.571728  C95.000648,74.403008 95.000648,112.329529 95.000610,150.721069  z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#019D9C",
    opacity: 1,
    stroke: "none",
    d: " M104.010117,38.508007  C104.631584,37.401493 105.139488,36.326607 105.872131,36.141567  C130.011978,30.044754 154.173370,24.033230 178.696213,17.918190  C178.696213,57.483276 178.696213,96.714615 178.696213,136.480515  C154.118851,142.634521 129.376678,148.829803 104.001320,155.183624  C104.001320,116.142487 104.001320,77.548492 104.010117,38.508007  z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b681470acb9f0fd37b5732021ef36c15.svg";
export { ForwardRef as ReactComponent };